exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_facebookLogin_3C_rwOHc5BZnNk7v1unhvk {\n  font-family: Helvetica,sans-serif;\n  font-weight: 700;\n  -webkit-font-smoothing: antialiased;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-size: calc(.27548vw + 12.71074px);\n  text-decoration: none;\n  transition: background-color .3s,border-color .3s;\n  background-color: #4c69ba;\n  border: 10px solid #4c69ba;\n  border-radius: 5px;\n  margin-top: 20px;\n  width: 250px;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_facebookLogin": "IA_facebookLogin_3C_rwOHc5BZnNk7v1unhvk"
};